export const tabConfig = {
    announcements: { label: "Pull Announcements", key: "announcements", idField: "id", nameField: "title" },
    assignments: { label: "Pull Assignments", key: "assignments", idField: "id", nameField: "title" },
    discussions: { label: "Pull Discussions", key: "discussions", idField: "id", nameField: "title" },
    files: { label: "Pull Files", key: "files", idField: "file_id", nameField: "display_name" },
    modules: { label: "Pull Modules", key: "modules", idField: "module_id", nameField: "name" },
    pages: { label: "Pull Pages", key: "pages", idField: "page_id", nameField: "page_title" },
    enrollments: { label: "Pull Enrollments", key: "enrollments", idField: "id", nameField: "user.name" },
    quizzes: { label: "Pull Quizzes", key: "quizzes", idField: "id", nameField: "title" },
    syllabus: { label: "Pull Syllabus", key: "syllabus", idField: "module_id", nameField: "name" }
  } as const;

  // tabConfig.ts
export type VisibilityKey = 'announcements' | 'assignments' | 'discussions' | 'files' | 'modules' | 'pages' | 'enrollments' | 'quizzes' | 'syllabus';


  
  